import { render } from "./DropdownItem.vue?vue&type=template&id=09a2f9fa"
import script from "./DropdownItem.vue?vue&type=script&lang=js"
export * from "./DropdownItem.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./DropdownItem.vue?vue&type=style&index=0&id=09a2f9fa&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script